import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../Services/useAuth';
import useUser from '../hooks/useUser';

export default function AppDashboard() {
  const { getUser, token, handleTokenExpiration } = useAuth();
  const { isNewUser } = useUser();
  const isAdmin = getUser()?.is_admin === 1;
  const isActive = getUser()?.is_active === 1;
  const isSuperAdmin = getUser()?.is_super_admin === 1;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  useEffect(() => {
    handleTokenExpiration();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const newUserMenuItems = [
    { key: 1, label: 'Αλλαγή email', path: '/email' },
    {
      key: 2,
      label: 'Ιστορικό αιτήσεων απογραφής',
      path: '/request-old-history',
    },
    { key: 3, label: 'Προτάσεις', path: '/questions' },
    { key: 4, label: 'Έξοδος', path: '/' },
  ];
  const adminMenuItems = [
    { key: 1, label: 'Ολες οι αιτήσεις', path: '/request-management' },
    { key: 2, label: 'Ολα τα ερωτήματα', path: '/questions-management' },
    { key: 3, label: 'Ομάδες Επικοινωνίας', path: '/groups-management' },
    {
      key: 4,
      label: 'Διαχείριση Ερωτημάτων',
      path: '/questions-categories-management',
    },
    { key: 5, label: 'Έξοδος', path: '/' },
  ];
  const superAdminMenuItems = [
    { key: 1, label: 'Ολες οι αιτήσεις', path: '/request-management' },
    { key: 2, label: 'Ολα τα ερωτήματα', path: '/questions-management' },
    { key: 3, label: 'Ομάδες Επικοινωνίας', path: '/groups-management' },
    {
      key: 4,
      label: 'Διαχείριση Ερωτημάτων',
      path: '/questions-categories-management',
    },
    { key: 5, label: 'Διαχειριστές', path: '/admins-management' },
    { key: 6, label: 'Έξοδος', path: '/' },
  ];
  const userMenuItems = [
    { key: 1, label: 'Στοιχεία μητρώου', path: '/registry-review' },
    { key: 2, label: 'Ιστορικό μου', path: '/request-history' },
    {
      key: 3,
      label: 'Ιστορικό αιτήσεων απογραφής',
      path: '/request-old-history',
    },
    { key: 4, label: 'Αλλαγή email', path: '/email' },
    { key: 5, label: 'Προτάσεις', path: '/questions' },
    {
      key: 6,
      label: 'Διαγραφή χρήστη',
      path: '/new-question?identifier=delete',
    },
    { key: 7, label: 'Έξοδος', path: '/' },
  ];
  const inactiveUserMenuItems = [{ key: 1, label: 'Έξοδος', path: '/' }];

  const getMenu = () => {
    if (isAdmin && !isSuperAdmin) {
      return adminMenuItems;
    } else if (isAdmin && isSuperAdmin) {
      return superAdminMenuItems;
    } else if (isNewUser && isActive) {
      return newUserMenuItems;
    } else if (!isActive && !isAdmin) {
      return inactiveUserMenuItems;
    } else if (isActive && !isAdmin) {
      return userMenuItems;
    }
    return inactiveUserMenuItems;
  };

  const activeMenu = getMenu();

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-label="menu"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon sx={{ color: 'white.main' }} />
      </IconButton>
      {
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {activeMenu.map((item, index) => (
            <MenuItem
              key={index}
              sx={{ color: 'primary.main' }}
              onClick={() => {
                item.label === 'Έξοδος'
                  ? navigate('/logout-redirect')
                  : navigate(item.path);
                handleClose();
              }}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>
      }
    </div>
  );
}
